import { isEmpty } from '../lib/validator/helpers'

export default {
  computed: {
    firstOffer () {
      return this.offers[0]
    },

    currentOfferHasPacks () {
      return this.chosenOffer.devices_packs !== undefined && this.chosenOffer.devices_packs.length > 0
    },

    isDevicesCategoryLeaf () {
      return this.devices.map(device => !isEmpty(device.chosenCategory?.parent))
    },

    /** PACKS METHODS */
    packIdentifiers () {
      return this.chosenOffer === undefined || this.chosenOffer.devices_packs === undefined
        ? []
        : this.chosenOffer.devices_packs.map(pack => pack.identifier)
    },

    packIdentifierChosen () {
      return this.devices
        .map(device => device.pack_identifier)
        .filter(identifier => !isEmpty(identifier))
        .filter((identifier, index, arr) => arr.indexOf(identifier) === index)
    },

    packIdentifiersAvailable () {
      return this.packIdentifiers.filter(identifier => !this.packIdentifierChosen.includes(identifier))
    },

    /** GET CATEGORY NAMES OF PACK from the packs of the current offer */
    packsCategories () {
      const packsCategories = []
      this.chosenOffer.devices_packs.content
        .forEach(pack => pack.forEach(packCategories => packCategories.forEach(cat => packsCategories.push(cat.category.name))))
      return packsCategories
    },

    lastDeviceIsAPack () {
      return this.devices.length === 1 && !isEmpty(this.currentDevice.pack_identifier)
    },

    /** LIST OF CHOSEN CATEGORIES PRESENT IN PACKS */
    categoriesChosenPresentInPacks () {
      return this.devices.map(device => device.chosenCategory?.name)
        /* Filter them to get only the not null and if they are on categories of packs */
        .filter(cat => this.packsCategories.indexOf(cat) !== -1)
    },

    /** Sort devices packs by size descending
     ** Useful to test packs with most categories first */
    devicesPacksSortedLengthDesc () {
      return [...this.chosenOffer.devices_packs.content].sort((packA, packB) => packB.length - packA.length)
    },

    devicesNumberWithoutPacksOld () {
      /** devicesNumber = number leaves category - categories chosen present in packs */
      return this.devices.filter(device => !isEmpty(device.chosenCategory?.parent)).length - this.categoriesChosenPresentInPacks.length
    },

    devicesNumberWithoutPacks () {
      return this.devices.filter(device => device.pack_identifier === undefined).length
    },

    devicesNumberOld () {
      let devicesNumber = this.devicesNumberWithoutPacks
      const devicesPacksSortedLengthDesc = [...this.devicesPacksSortedLengthDesc]
      const categoriesChosenPresentInPacks = [...this.categoriesChosenPresentInPacks]
      let isPacksFull = true

      while (devicesPacksSortedLengthDesc.length !== 0 && categoriesChosenPresentInPacks.length !== 0) {
        if (this.packWithMostCatHasAvailableCategory(devicesPacksSortedLengthDesc, categoriesChosenPresentInPacks)) isPacksFull = false

        devicesNumber++

        /** We make a copy, else the pack would be splice */
        const devicesPacksCopy = [...devicesPacksSortedLengthDesc]
        /** Remove the pack from the list */
        devicesPacksSortedLengthDesc.splice(this.indexPackWithMostCat(devicesPacksSortedLengthDesc, categoriesChosenPresentInPacks), 1)
        /** Remove categories of the pack with most cat from the list categories */
        this.categoriesChosenFromPackWithMostCat(devicesPacksCopy, categoriesChosenPresentInPacks)
          .forEach(cat => categoriesChosenPresentInPacks
            .splice(categoriesChosenPresentInPacks.findIndex(listCatElement => listCatElement === cat), 1))
      }

      return [
        devicesNumber + categoriesChosenPresentInPacks.length, isPacksFull
      ]
    },

    packCategoriesNumber () {
      return this.chosenOffer.devices_packs.reduce((acc, pack) => {
        acc[pack.identifier] = pack.content.length
        return acc
      }, {})
    },

    packsNumber () {
      const identifierOccurrences = this.devices
        .filter(device => device.pack_identifier !== null && device.pack_identifier !== undefined)
        .map(device => device.pack_identifier)
        .reduce((acc, identifier) => (acc[identifier] = (acc[identifier] || 0) + 1, acc), {})

      let count = 0
      for (const [identifier, occurrence] of Object.entries(identifierOccurrences)) {
        count += Math.ceil(occurrence / this.packCategoriesNumber[identifier])
      }

      return count
    },

    devicesNumber () {
      return this.devicesNumberWithoutPacks + this.packsNumber
    },

    /** END PACKS COMPUTED */

    /** RETURN A LIST OF CATEGORIES by checking (if present)
     * max devices per categories
     * mandatory devices
     * parent category
     * */
    categoriesShowed () {
      /** MAX DEVICES PER CATEGORY FILTER */
      const filterCatAlreadyTakenMaxTimes = categories => {
        const categoryNames = categories.map(cat => cat.name)

        this.chosenOffer.max_devices_per_category.forEach(maxCat => {
          const currentMaxDevicesWithCat = this.devices.filter(device => device.chosenCategory?.name === maxCat.category.name).length

          /* If number of devices with this cat is more or equal to the max device possible for this category, remove the category from the list */
          if (currentMaxDevicesWithCat >= maxCat.max) {
            if (~categoryNames.indexOf(maxCat.category.name)) {
              categories.splice(categoryNames.indexOf(maxCat.category.name), 1)
              categoryNames.splice(categoryNames.indexOf(maxCat.category.name), 1)
            }
          }
        })
        return categories
      }

      /** MANDATORY DEVICES FILTER */
      const filterMandatoryDevices = _ => {
        /* Get number of device category filled */
        const availableDevicesNumber = this.devices.filter(device => device.chosenCategory === null).length

        const catOccurrences = this.get_mandatory_occurences()
        const listCat = this.list_cat_related_to_mandatory_devices(catOccurrences)

        /* Get number of mandatory devices left */
        const mandatoryCategoriesNumberLeft = this.get_mandatory_categories_number_left(listCat)

        /* If there is more empty categories device than mandatory devices left */
        if (availableDevicesNumber > mandatoryCategoriesNumberLeft) {
          return null
        } else {
          let mandatoryDevices = [...this.chosenOffer.mandatory_devices]
          let mandatoryDevicesFiltered

          /* Verification for obligatory devices
           * Get the mandatory devices when none of their categories are selected in devices */
          if (listCat.length > 0) {
            mandatoryDevicesFiltered = this.get_obligatory_devices_left(mandatoryDevices, listCat)
          }

          if (mandatoryDevicesFiltered === undefined || availableDevicesNumber > mandatoryDevicesFiltered.length) {
            /* Get occurrences of chosen categories present in mandatory devices */
            const myCatOccurrences = {}
            listCat.forEach(cat => {
              myCatOccurrences[cat] === undefined
                ? myCatOccurrences[cat] = 1
                : ++myCatOccurrences[cat]
            })

            /* Get allowed devices categories needed left needed */
            mandatoryDevices = this.get_mandatory_devices_left(mandatoryDevices, myCatOccurrences, catOccurrences)
          } else {
            mandatoryDevices = mandatoryDevicesFiltered
          }

          const catOfMandatoryDevices = mandatoryDevices.map(deviceMandatory => deviceMandatory.allowed_categories)
            .flat(2)

          /* remove duplicates categories */
          const catOfMandatoryDevicesWithoutDuplicates = []
          catOfMandatoryDevices.forEach(categories => {
            if (!(catOfMandatoryDevicesWithoutDuplicates.some(cat => cat.name === categories.name))) {
              catOfMandatoryDevicesWithoutDuplicates.push(categories)
            }
          })

          /* If there is one category option possible */
          if (catOfMandatoryDevicesWithoutDuplicates.length === 1) {
            this.currentDevice.chosenCategory = catOfMandatoryDevices[0]
          } else {
            this.currentDevice.chosen_cat = 'multiple_cat'
            return catOfMandatoryDevicesWithoutDuplicates
          }
        }
      }

      /** PACKS FILTER */
      const filter_pack = _ => {
        const [devicesNumber, isPacksFull] = this.devicesNumber

        /* Test if there is as many devices than the max possible && packs are not full */
        if (devicesNumber === this.chosenOffer.max_devices && !isPacksFull) {
          const categories = this.categoriesFromPacksInProgress()

          if (categories.length === 1) {
            this.currentDevice.chosenCategory = categories[0]
          } else {
            return categories
          }
        }
        return null
      }

      const applyOptionForCategories = categories => {
        let categoriesFromOption
        /* Get the mandatory devices if needed (can remove the current categories packs because mandatory devices is more important) */
        if (this.chosenOffer.mandatory_devices) {
          categoriesFromOption = filterMandatoryDevices()
        }

        /* Return the list of allowed items of packs left IF there is no more place for a new device and the pack is not complete */
        /*        if (this.chosen_offer.devices_packs.content && !categoriesFromOption) {
         categoriesFromOption = filter_pack()
         } */

        categories = categoriesFromOption || categories

        /* remove the categories with already max devices for this category */
        if (this.chosenOffer.max_devices_per_category) {
          categories = filterCatAlreadyTakenMaxTimes(categories)
        }

        return [categories, categoriesFromOption]
      }

      const showCategoriesWhenNoParentSelected = _ => {
        const [officialCategories, optionPackOrMandApplied] = applyOptionForCategories([...this.chosenOffer.allowed_devices_categories])

        if (officialCategories === undefined) {
          return null
        } else if (officialCategories.length === 1) {
          this.currentDevice.chosenCategory = officialCategories[0]
        } else if (optionPackOrMandApplied || officialCategories.length <= 6) {
          return this.categoriesSorted(officialCategories)
        } else {
          /* else return the parents without duplicate and sorted */
          return this.categoriesSorted(this.categoriesWithoutDuplicates(officialCategories
            .map(cat => ({ name: cat.parent }))))
        }
      }

      const showCategoriesWhenParentSelected = _ => {
        /* else If a category parent is selected */
        /* Filter the children of this parent category */
        const categories = this.chosenOffer.allowed_devices_categories.filter(cat => cat.parent === this.currentDevice.chosenCategory.name)

        switch (categories.length) {
          /* If there is no children that means it's a leaf */
          case 0:
            return []
          /* if there is one children, we can already set this children cat for the current device  */
          case 1:
            this.currentDevice.chosenCategory = categories[0]
            return showCategoriesWhenParentSelected()
          /* Else there is multiple children */
          default:
            return [...applyOptionForCategories(categories)[0]]
        }
      }

      return this.currentDevice.chosenCategory === null
        ? showCategoriesWhenNoParentSelected()
        : showCategoriesWhenParentSelected()
    },

    canAddDevice () {
      return this.devicesNumber < this.chosenOffer.max_devices
      /*      if (this.chosen_offer.devices_packs.content)
       /!* Test if they are no device categories empty *!/
       {
       if (this.devices.filter(device => device.chosenCategory === null).length === 0) {
       /!* Get all device categories which are present in at least a pack *!/
       const [devicesNumber, isPacksFull] = this.devicesNumber

       /!* Test if there is less device than the max possible or if packs are not full *!/
       return devicesNumber < this.chosen_offer.max_devices ||
       (devicesNumber === this.chosen_offer.max_devices && !isPacksFull)
       }
       }
       return this.chosen_offer.max_devices > this.devices.length */
    },

    /** DEVICE WITH CAN DELETE PROPERTY */
    /* Return my devices by adding can delete property (computed) for each device. Calculate device everytime a single property change */
    devices_with_can_delete () {
      /* Allow us to calculate same category (or empty) only one time */
      const state_of_categories = {}

      /** CAN DELETE DEVICE */
      const can_delete_device = index => {
        /* Verify that the current device is not mandatory */
        if (this.chosenOffer.mandatory_devices) {
          const current_category = this.devices[index].chosenCategory.name

          if (state_of_categories[current_category] === undefined) {
            if (this.devices.length <= this.chosenOffer.min_devices) {
              return state_of_categories[current_category] = false
            } else {
              const cat_occurences = this.get_mandatory_occurences()
              const list_cat = this.list_cat_related_to_mandatory_devices(cat_occurences)

              if (current_category === null || list_cat.indexOf(current_category) !== -1) {
                /* Make a copy of device, we don't want to actually remove the category of the current device, it's just to test if we can delete it */
                const devices = [...this.devices]
                /* Make a copy of current object device */
                const device = Object.assign({}, devices[index])
                devices[index] = device
                if (list_cat.indexOf(current_category) !== -1) {
                  this.$set(device, 'category_name', null)
                  list_cat.splice(list_cat.indexOf(current_category), 1)
                }
                const availableDevicesNumber = devices.filter(device => device.chosenCategory.name === null).length

                /* Get number of mandatory devices left */
                const mandatory_categories_number_left = this.get_mandatory_categories_number_left(list_cat)

                /* If there is more empty categories device than mandatory devices left */
                if (availableDevicesNumber <= mandatory_categories_number_left) {
                  return state_of_categories[current_category] = false
                }
              }
              state_of_categories[current_category] = true
            }
          } else {
            return state_of_categories[current_category]
          }
        }
        return this.devices.length > this.chosenOffer.min_devices
      }

      return this.devices.map((device, index) => {
        device.can_delete = can_delete_device(index)
        return device
      })
    },

    /** Show or not the CROSS next to a category chosen */
    can_remove_category () {
      const currentCatName = this.currentDevice.chosenCategory.name

      /* DEVICES PACKS */
      if (this.chosenOffer.devices_packs.content) {
        /* Get all device categories which are present in at least a pack */
        const categoriesChosenPresentInPacks = [...this.categoriesChosenPresentInPacks]

        if (categoriesChosenPresentInPacks.includes(currentCatName)) {
          const [devicesNumber] = this.devicesNumber

          if (devicesNumber === this.chosenOffer.max_devices) {
            /* Remove current cat from the list cat to simulate the step before it was chosen */
            categoriesChosenPresentInPacks.splice(categoriesChosenPresentInPacks.indexOf(currentCatName), 1)

            let categories = this.categoriesFromPacksInProgress(categoriesChosenPresentInPacks)
            /* Remove duplicates */
            categories = categories.filter((cat, index) => categories.findIndex(category => category.id === cat.id) === index)

            if (categories.length === 1/* && categories[0] === currentCatName */) {
              return false
            }
          }
        }
      }

      /** MANDATORY DEVICES */
      if (this.chosenOffer.mandatory_devices) {
        const cat_occurences = this.get_mandatory_occurences()
        const categoriesChosenPresentInPacks = this.list_cat_related_to_mandatory_devices(cat_occurences)

        /* If the current category is present in categories of mandatory devices */
        if (categoriesChosenPresentInPacks.indexOf(current_cat_name) !== -1) {
          /* If there is less (or equal) devices with the current category than the max possible in mandatory_devices */
          if (categoriesChosenPresentInPacks.filter(cat => current_cat_name === cat).length <= cat_occurences[current_cat_name]) {
            /* Remove the current device category from the categories list to simulate the case where the current category is a mandatory device */
            categoriesChosenPresentInPacks.splice(categoriesChosenPresentInPacks.indexOf(current_cat_name), 1)

            /* GET occurences of the chosen device categories */
            const my_cat_occurences = {}
            categoriesChosenPresentInPacks.forEach(cat => {
              my_cat_occurences[cat] === undefined
                ? my_cat_occurences[cat] = 1
                : ++my_cat_occurences[cat]
            })

            /* For each occurences of categories chosen, if they are more than occurences of mandatory devices, set them to the max */
            for (const [key, value] of Object.entries(my_cat_occurences)) {
              if (cat_occurences[key] < value) {
                my_cat_occurences[key] = cat_occurences[key]
              }
            }

            let mandatory_devices = [...this.chosenOffer.mandatory_devices]

            /* Get number of device category name filled */
            const availableDevicesNumber = this.devices.filter(device => device.chosenCategory.name === null).length

            /* GET obligatory categories left needed */
            /* Usefull when none of devices categories occurences are equal or superior to mandatory devices categories occurences */
            const mandatory_devices_filtered = this.get_obligatory_devices_left(mandatory_devices, list_cat)

            /* If mandatory devices left contain one cat max each, and each cat mandatory is the current category name=> then  we can't remove the current cat */
            /* Testing that there is more mandatory devices than available (empties) devices categories is usefull when there is empties
             devices categories that won't return the current category */
            if (mandatory_devices_filtered.length !== 0 && mandatory_devices_filtered.length > availableDevicesNumber && mandatory_devices_filtered.every(mandatory_device => mandatory_device.allowed_categories.length === 1) && mandatory_devices_filtered.every(mandatory_device => mandatory_device.allowed_categories[0].name === current_cat_name)) {
              return false
            }

            mandatory_devices = this.get_mandatory_devices_left(mandatory_devices, my_cat_occurences, cat_occurences)

            /* Same verifications as obligatory devices left */
            if (mandatory_devices.length !== 0 && mandatory_devices_filtered.length > availableDevicesNumber && mandatory_devices.every(mandatory_device => mandatory_device.allowed_categories.length === 1) && mandatory_devices.every(mandatory_device => mandatory_device.allowed_categories[0].name === current_cat_name)) {
              return false
            }
          }
        }
      }
      /* Don't show cross if there is only one category available */
      return this.chosenOffer.allowed_devices_categories.length > 1
    },

    mandate_signature_to_string () {
      return this.mandate_signature === '1'
        ? 'En ligne, immédiatement'
        : 'Différée, par mail'
    },

    payment_frequency_to_string () {
      return this.payment_frequency === 'm' ? 'Mensuel' : 'Annuel'
    },

    chosenOffer () {
      return this.offers.find(offer => offer.identifier === this.chosenOfferIdentifier)
    },

    /* RESUME */
    productsSummaryData () {
      let price = this.showFullPrice(this.chosenOffer)

      if (this.chosenOffer.offer_price_mode === 'PER_DEVICE' && this.devices.length > 1) price += ' (TOTAL: ' + this.chosenOffer.offer_price * this.devices.length + ' €)'

      const productsSummaryData = [
        {
          name: 'Nom de l\'offre',
          value: this.chosenOffer.name
        }, {
          name: 'Nombre d\'appareils assurés',
          value: this.devices.length
        }, {
          name: 'Prix',
          value: price
        }
      ]

      if (this.chosenOffer.theft_protection) {
        productsSummaryData.push({
          name: 'Protection vol',
          value: 'incluse'
        })
      }
      return productsSummaryData
    },

    customerSummaryData () {
      const productsSummaryData = [
        {
          name: 'Nom',
          value: this.customerFullName
        }, {
          name: 'Date de naissance',
          value: this.dateToString(this.customer_infos.birthdate)
        }, {
          name: 'E-mail',
          value: this.customer_infos.email
        }, {
          name: 'Téléphone mobile',
          value: this.customer_infos.mobile_phone_number
        }, {
          name: 'Adresse',
          value: this.customerAddressReformed.join('<br/>') + '<br/>' + this.customer_infos.postal_code + ' ' + this.customer_infos.city
        }
      ]

      if (this.customer_infos.phone_number) productsSummaryData.splice(4, 0, {
        name: 'Téléphone fixe',
        value: this.customer_infos.phone_number
      })

      if (this.customer_infos.company_name) productsSummaryData.splice(5, 0, {
        name: 'Entreprise',
        value: this.customer_infos.company_name
      })

      if (this.customer_infos.company_siren) productsSummaryData.splice(6, 0, {
        name: 'Siren',
        value: this.customer_infos.company_siren
      })

      return productsSummaryData
    },

    paymentSummaryData () {
      return [
        {
          name: 'IBAN',
          value: this.iban
        }, {
          name: 'Fréquence de paiement',
          value: this.payment_frequency_to_string
        }, {
          name: 'Signature du mandat',
          value: this.mandate_signature_to_string
        }
      ]
    },

    devicesSummaryData () {
      return this.devices.map(device => {
        const deviceSummaryData = [
          {
            name: 'Appareil',
            value: device.chosenCategory.name + ' ' + device.brand
          }, {
            name: 'Modèle',
            slug: 'model'
          }, {
            name: 'Prix d\'achat €',
            value: device.purchase_price
          }, {
            name: 'Date d\'achat',
            value: this.dateToString(device.purchase_date)
          }
        ]

        if (device.serialNumber) deviceSummaryData.splice(4, 0, {
          name: 'Numéro de série',
          value: device.serialNumber
        })

        return deviceSummaryData
      })
    }
  }
}
